import config from "src/config";
import http from "../services/apiServices";

export const getByPropertyId = async (propertyId: any) => {
  return await http.get(
    config.BMCCompany.getAssignedBuilding + propertyId + "&IsActive=true"
  );
  //return await http.get(config.BMCCompany.getByContractId);
  //return { propertyId: 1, buildingName: "cat1", address: "test address" };
};

export const getByContractNumber = async (contractNumber: any) => {
  return await http.get(config.BMCCompany.getByContractId + contractNumber);
};

export const contactTypeAPI = async () => {
  //await http.get("https://jsonplaceholder.typicode.com/posts/112");
  return [
    { id: 1, name: "annual" },
    { id: 2, name: "completed" },
  ];
};

export const getSystemsAPI = async () => {
  //await http.get("https://jsonplaceholder.typicode.com/posts/1");
  return [
    { id: 1, name: "Fire Alarm", iconName: "test" },
    { id: 2, name: "Elevator", iconName: "test" },
    { id: 3, name: "Diesel Pump", iconName: "test" },
    { id: 4, name: "Specialized Fire Alarm System", iconName: "test" },
    { id: 5, name: "Air and smoke control system", iconName: "test" },
    { id: 6, name: "Mechanical ventilation systems", iconName: "test" },
  ];
};

export const saveAPI = async (data: any) => {
  return await http.post(config.BMCCompany.saveAPI, data);
};

export const contactStatusAPI = async () => {
  //await http.get("https://jsonplaceholder.typicode.com/posts/1");
  return [
    { id: 1, name: "Expired" },
    { id: 2, name: "Running" },
  ];
};

export const unAssignBuildingAPI = async (data:any) => {
  return http.post(config.BMCCompany.unAssingBuilding, data);
};

export const getAssignedBuildingsAPI = async (data: any) => {
  return await http.post(config.BMCCompany.retrieveBuildingsByBMC, data);
};

export const validateContractNumberUniquenessAPI = async (
  contractNumber: any
) => {
  return await http.get(config.BMCCompany.ValidateContractNumber, {
    params: {
      contractNumber,
    },
  });
};

export const getEngineerTechnicianAPI = async (data: any) => {
  return await http.post(
    config.BMCCompany.retrieveEngineerTechnicianByBMC,
    data
  );
};

export const retrieveBuildingInfoByIdAPI = async (propertyId: string) => {
  return await http.get(config.BMCCompany.retrieveBuildingInfoById, {
    params: {
      propertyId,
    },
  });
};

export const validateContractNumberUniques = async (data: any) => {
  return await http.post(
    config.BMCCompany.isPhoneNumberUnique +
      `?PhoneNumber=${encodeURIComponent(data.PhoneNumber)}&Id=${data.Id}`,
    null
  );
};
export const validateUnassignSystemContractAPI = async (data: any) => {
  return await http.post(
    config.BMCCompany.validateUnassignSystemContract,
    data
  );
};

export const unAssingSystemServicesAPI = async (data: any) => {
  return await http.post(config.BMCCompany.unAssignSystemServices, data);
};

export const retrieveSystemServicesByBuildingAPI = async (
  propertyId: string
) => {
  return await http.get(config.BMCCompany.retrieveSystemServicesByBuilding, {
    params: {
      propertyId,
    },
  });
}
export const validateSystemServiceAPI = async (data: any) => {
  return await http.post(config.BMCCompany.validateSystemService, data);
};
